module.exports = __webpack_public_path__ + "static/media/chevron_gray.89b5bfd4.svg";